import { memo } from "react";
import TextCell from "./TextCell";

const SEPARATOR = "; ";

/**
 * A list of short free-text values typed as `a; b; c` — formula variables.
 * Reads as plain text, so a row of them stays scannable.
 *
 * @param {object} props
 * @param {string[]} props.value
 * @param {boolean} [props.dirty]
 * @param {string} [props.error]
 * @param {boolean} [props.disabled]
 * @param {string} props.ariaLabel
 * @param {string} [props.placeholder]
 * @param {(value: string[]) => void} props.onChange
 */
function ListCell({ value, dirty, error, disabled, ariaLabel, placeholder, onChange }) {
  return (
    <TextCell
      value={(value || []).join(SEPARATOR)}
      dirty={dirty}
      error={error}
      disabled={disabled}
      ariaLabel={ariaLabel}
      placeholder={placeholder}
      onChange={(text) =>
        onChange(
          text
            .split(";")
            .map((part) => part.trim())
            .filter(Boolean),
        )
      }
    />
  );
}

export default memo(ListCell);
